import { useContext, useEffect, useRef, useState } from "react";
import {
  formatDate,
  formatDateForInput,
  getCurrentDate,
  getCurrentMonthName,
  getCurrentTime,
  getDateRangeForYear,
  getDaysPassed,
  getPreviousDate,
  parseDateString,
} from "../constant";
import useAxios from "../common/hook/useAxios";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-toastify";
import { AiOutlineFileExcel } from "react-icons/ai";
import { MdPictureAsPdf } from "react-icons/md";
import {
  FaCheckCircle,
  FaFileExcel,
  FaFilePdf,
  FaPrint,
  FaSearch,
  FaStar,
} from "react-icons/fa";
import Modal from "react-modal";
import SidebarComponent from "./Sidebar";
import LabCompliancePopup from "./LabCompliancePopup";

const LabCompilanceComponent = ({
  tableData,
  setFromDate,
  setToDate,
  fromDate,
  toDate,
  handleSearch,
  isCheckedIn,
  setIsCheckedIn,
}) => {
  const dataTableRef = useRef(null);
  const navigate = useNavigate();
  const { request } = useAxios();
  const { user } = useContext(AuthContext);
  const [error, setError] = useState("");
  const [view, setView] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [screeningDOS, setScreeningDOS] = useState("");
  const [lastScreeningDOS, setLastScreeningDOS] = useState("");
  const [nextScreningDOS, setNextScreeningDOS] = useState("");
  const [confirmationDOS, setConfirmationDOS] = useState("");
  const [lastConfirmationDOS, setLastConfirmationDOS] = useState("");
  const [nextConfirmationDOS, setNextConfirmationDOS] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [patientId, setPatientId] = useState("");

  // useEffect(() => {
  //   getModalData();
  // }, []);

  const getModalData = async () => {
    const FromDate = formatDate(fromDate);
    const ToDate = formatDate(toDate);
    const url = `${process.env.REACT_APP_TEMPLATES_URL}/LabResults/PatientLabResultSummary?sInputJSON={"objLab":{"PatientID":${patientId}, "PracticeId":"${user?.PracticeID}","FromDOS":"${FromDate}","ToDOS":"${ToDate}", "isFromLabOrder":0, "isCheckedIn":${isCheckedIn ? 1 : 0}}}`;
    request(url, {
      headers: {
        Authorization: `Bearer ${user?.AuthToken}`,
      },
      method: "GET",
    })
      .then((res) => {
        setModalData(res);
      })
      .catch(() => {
        toast.error("Error occurred in lab compliance", {
          autoClose: 3000,
        });
      });
  };

  // let filteredPatients;
  const filteredPatients =
    Array.isArray(tableData) &&
    tableData?.length > 0 &&
    tableData?.filter((row) => {
      const fullName = `${row.FirstName} ${row.LastName}`?.toLowerCase();
      const searchTermNormalized = searchTerm?.trim()?.toLowerCase();
      const screeningDOSMatches = row?.SCRDOS && row?.SCRDOS?.toLowerCase().includes(
        screeningDOS?.toLowerCase(),
      );
      const lastScreeningDOSMatches = row?.LastSCRDOS?.toLowerCase().includes(
        lastScreeningDOS?.toLowerCase(),
      );
      const nextScreeningDOSMatches = row?.NextSCRDOS?.toLowerCase().includes(
        nextScreningDOS?.toLowerCase(),
      );
      const confirmationDOSMatches = row?.CNFDOS?.toLowerCase().includes(
        confirmationDOS?.toLowerCase(),
      );
      const lastConfirmationDOSMatches =
        row?.LastCNFDOS?.toLowerCase().includes(
          lastConfirmationDOS?.toLowerCase(),
        );
      const nextConfirmationDOSMatches =
        row?.NextCNFDOS?.toLowerCase().includes(
          nextConfirmationDOS?.toLowerCase(),
        );

      return (
        fullName.includes(searchTermNormalized)
        &&
        (screeningDOSMatches || (!screeningDOS && row?.SCRDOS === null))
        &&
        (lastScreeningDOSMatches || (!lastScreeningDOS && row?.LastSCRDOS === null))
        &&
        (nextScreeningDOSMatches || (!nextScreningDOS && row?.NextSCRDOS === null))
        &&
        (confirmationDOSMatches || (!confirmationDOS && row?.CNFDOS === null))
        &&
        (nextConfirmationDOSMatches || (!nextConfirmationDOS && row?.NextCNFDOS === null)) &&
        (lastConfirmationDOSMatches || (!lastConfirmationDOS && row?.LastCNFDOS === null))
      );
    });

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handlePrint = () => {
    if (dataTableRef.current) {
      const tableHTML = dataTableRef.current.outerHTML;
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`

        <html>
          <head>
            <title>Lab Compliance Print</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                padding: 20px;
              }
              table {
                width: 100%;
                border-collapse: collapse;
              }
              th, td {
                border: 1px solid #ccc;
                padding: 8px;
                text-align: left;
              }
             th {
                    background-color: #f4f4f4;
                    font-size:16px;
                  }
                    td{
                    font-size:14px}
                        @media print {
  .hide-on-print {
    display: none !important;
  }
}
            </style>
          </head>
          <body>
            ${tableHTML}
          </body>
        </html>
      `);

      printWindow.document.close();
      printWindow.print();
    } else {
      console.error("Table reference is not set.");
    }
  };

  const handleExcel = () => {
    if (dataTableRef.current) {
      const tableHtml = dataTableRef.current.innerHTML;
      const data = { PrintableData: tableHtml, PageName: "Lab Compliance New" };
      request(`${process.env.REACT_APP_LOGIN_API_URL}/DataExport/Excel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(JSON.stringify(data)),
      })
        .then((res) => {
          const fileUrl = res[2]; // Assuming the URL is in the third position of the response array
          if (fileUrl) {
            // Create a temporary anchor element
            window.open(fileUrl, "_blank");
          } else {
            throw new Error("No download URL provided");
          }
        })
        .catch(() => {
          toast.error("Error occured while generating excel", {
            autoClose: 3000,
          });
        });
    }
    // Add your logic for Excel export here
  };

  const handlePdf = () => {
    if (dataTableRef.current) {
      const tableHtml = dataTableRef.current.innerHTML;
      const data = { PrintableData: tableHtml, PageName: "Lab Compliance New" }; //static
      request(`${process.env.REACT_APP_LOGIN_API_URL}/DataExport/PDF`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(JSON.stringify(data)),
      })
        .then((res) => {
          const fileUrl = res[2]; // Assuming the URL is in the third position of the response array
          if (fileUrl) {
            // Create a temporary anchor element
            window.open(fileUrl, "_blank");
          } else {
            throw new Error("No download URL provided");
          }
        })
        .catch(() => {
          toast.error("Error occured while generating pdf", {
            autoClose: 3000,
          });
        });
    }
  };

  const toggle = (id) => {
    // console.log(id);
    setPatientId(id);
    setIsOpen(!isOpen);
    return getModalData();
  };

  return (
    <div>
      <Modal
        isOpen={isOpen}
        onRequestClose={toggleMenu}
        className={`absolute flex flex-col min-w-max top-8  p-4 right-0 w-48 bg-white shadow-lg rounded-lg transition-transform duration-300 ease-in-out transform ${isOpen ? "translate-y-0 opacity-100" : "-translate-y-4 opacity-0"
          }`}
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
      >
        <LabCompliancePopup
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
          tableData={modalData}
          handleSearch={getModalData}
        />
      </Modal>
      <div className="bg-gray-200 text-center text-black text-2xl font-semibold">
        Patient Urine Test Screen
      </div>
      <header className="bg-blue-200 text-black p-4 flex items-center w-full">
        <div className="flex items-center space-x-4">
          <label
            htmlFor="from-date"
            className="block text-md font-medium text-white-300"
          >
            From:
          </label>
          <input
            type="date"
            id="from-date"
            value={formatDateForInput(fromDate)}
            onChange={(e) => {
              const dateString = e.target.value;
              const newDate = parseDateString(dateString);
              if (newDate) {
                setFromDate(newDate); // Update the state with Date object
                setError(""); // Clear any previous errors
              } else {
                setError("Invalid date format.");
              }
            }}
            className="mt-1 block w-[200px] px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          />
          {/* </div> */}
          {/* <div> */}
          <label
            htmlFor="to-date"
            className="block text-md font-medium text-white-300"
          >
            To:
          </label>
          <input
            type="date"
            id="to-date"
            value={formatDateForInput(toDate)}
            onChange={(e) => {
              const dateString = e.target.value;
              const newDate = parseDateString(dateString);
              if (newDate) {
                setToDate(newDate); // Update the state with Date object
                setError(""); // Clear any previous errors
              } else {
                setError("Invalid date format.");
              }
            }}
            className="mt-1 block w-[200px]  px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          />
          <input
            type="checkbox"
            checked={isCheckedIn}
            onChange={(e) => {
              setIsCheckedIn(e.target.checked);
            }}
          />
          <label>Checked In</label>
          {/* </div> */}
          <button
            onClick={handleSearch}
            className="flex items-center bg-orange text-white py-2 px-4 rounded-md shadow-sm focus:outline-none"
          >
            <FaSearch className="mr-2" />
            Search
          </button>
          <div className="flex justify-between gap-4 p-2">
            <button
              onClick={handlePrint}
              className="text-blue-700 hover:text-blue-700 flex flex-col items-center transition-colors"
              title="Print"
            >
              <FaPrint size={24} />
              Print
            </button>
            <button
              onClick={handleExcel}
              className="text-green-700 flex flex-col items-center transition-colors"
              title="Export to Excel"
            >
              <AiOutlineFileExcel size={24} />
              Export as Excel
            </button>
            <button
              onClick={handlePdf}
              className="text-red-700 flex flex-col items-center transition-colors"
              title="Export to PDF"
            >
              <MdPictureAsPdf size={24} />
              Export as PDF
            </button>
          </div>
        </div>
      </header>
      <div className="flex flex-row items-center justify-around bg-[#005d97]">
        <h3
          className={` text-white hover:bg-blue-600 py-2 px-3 rounded-tr-lg rounded-bl-lg cursor-pointer ${view === "All" ? "bg-blue-600 shadow" : ""}`}
          onClick={() => setView("All")}
        >
          All
        </h3>
        <h3
          className={`text-white hover:bg-blue-600 py-2 px-3 rounded-tr-lg rounded-bl-lg cursor-pointer ${view === "Screening" ? "bg-blue-600" : ""}`}
          onClick={() => setView("Screening")}
        >
          Screening
        </h3>
        <h3
          className={`text-white hover:bg-blue-600 py-2 px-3 rounded-tr-lg rounded-bl-lg cursor-pointer ${view === "Confirmation" ? "bg-blue-600" : ""}`}
          onClick={() => setView("Confirmation")}
        >
          Confirmation
        </h3>
      </div>
      <div ref={dataTableRef} className="p-2 overflow-x-scroll h-screen">
        <table
          // ref={dataTableRef}
          className="min-w-full bg-white border border-gray-300"
        >
          <thead>
            <tr className="bg-[#005d97] border-b border-black text-white">
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                #
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                Patient Name <br></br>
                <input
                  type="text"
                  className="text-gray-800 text-sm mt-1 hide-on-print"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ marginBottom: "10px", padding: "5px" }}
                />
              </th>
              {view === "Confirmation" ? (
                <></>
              ) : (
                <>
                  <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    Screening <br></br>Request <br></br>DOS <br></br>
                    <input
                      type="text"
                      className="text-gray-800 text-sm mt-1 w-full hide-on-print"
                      placeholder="Search"
                      value={screeningDOS}
                      onChange={(e) => setScreeningDOS(e.target.value)}
                      style={{ marginBottom: "10px", padding: "5px" }}
                    />
                  </th>
                  <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    Last <br></br>Screening <br></br>Result <br></br>DOS{" "}
                    <br></br>
                    <input
                      type="text"
                      className="text-gray-800 text-sm mt-1 w-full hide-on-print"
                      placeholder="Search"
                      value={lastScreeningDOS}
                      onChange={(e) => setLastScreeningDOS(e.target.value)}
                      style={{ marginBottom: "10px", padding: "5px" }}
                    />
                  </th>
                  <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    Next <br></br>Screening <br></br>Run Dos <br></br>
                    <p className="text-sm">{getCurrentDate(new Date())}</p>
                    <div className="flex flex-row items-center justify-between my-1.5 gap-1 text-white ">
                      <input type="checkbox" />{" "}
                      <input
                        type="text"
                        className="w-16 rounded-lg text-gray-900 text-sm p-1 text-center hide-on-print"
                        placeholder="Days"
                      />
                      {/* <button className="bg-orange p-2 rounded-lg">
                        Random
                      </button>
                      <button className="bg-orange p-2 rounded-lg">
                        Intelli Lab
                      </button>{" "} */}
                    </div>
                    <input
                      type="text"
                      className="text-gray-800 text-sm mt-1 w-full hide-on-print"
                      placeholder="Search"
                      value={nextScreningDOS}
                      onChange={(e) => setNextScreeningDOS(e.target.value)}
                      style={{ marginBottom: "10px", padding: "5px" }}
                    />
                  </th>

                  <th scope="col" className="p-2 border-r border-black">
                    <table width="100%" cellpadding="2" cellspacing="1">
                      <tbody>
                        <tr>
                          <td colspan="2" align="center">
                            #Of <br></br>Screening <br></br>{" "}
                            <p className="text-sm">
                              ({getDaysPassed(new Date())}) <br></br>
                              {getCurrentMonthName(new Date())}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td width="50%">Req</td>
                          <td width="50%">
                            <span>Result</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </th>

                  <th scope="col" className="p-2 border-r border-black">
                    <table width="100%" cellpadding="2" cellspacing="1">
                      <tbody>
                        <tr>
                          <td colspan="2" align="center">
                            #Of <br></br>Screening <br></br>{" "}
                            <p className="text-sm">
                              (Year{" "}
                              {getDateRangeForYear(new Date()).map(
                                (line, index) => (
                                  <span key={index}>
                                    {line}
                                    <br />
                                  </span>
                                ),
                              )}
                              )
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td width="50%">Req</td>
                          <td width="50%">
                            <span>Result</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </th>
                </>
              )}
              {view === "Screening" ? (
                <></>
              ) : (
                <>
                  <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    Confirm <br></br>Request <br></br>DOS <br></br>
                    <input
                      type="text"
                      className="text-gray-800 text-sm mt-1 w-full hide-on-print"
                      placeholder="Search"
                      value={confirmationDOS}
                      onChange={(e) => setConfirmationDOS(e.target.value)}
                      style={{ marginBottom: "10px", padding: "5px" }}
                    />
                  </th>
                  <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    Last <br></br>Confirmation <br></br> Result DOS <br></br>
                    <input
                      type="text"
                      className="text-gray-800 text-sm mt-1 w-full hide-on-print"
                      placeholder="Search"
                      value={lastConfirmationDOS}
                      onChange={(e) => setLastConfirmationDOS(e.target.value)}
                      style={{ marginBottom: "10px", padding: "5px" }}
                    />
                  </th>
                  <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    Next <br></br>Confirmation <br></br>Run DOS <br></br>
                    {/* <CurrentDate /> */}
                    <div className="flex flex-row items-center justify-between my-1.5 gap-1 text-white ">
                      <input type="checkbox" />{" "}
                      <input
                        type="text"
                        className="w-16 rounded-lg text-gray-900 text-sm p-1 text-center"
                        placeholder="Days"
                      />
                      {/* <button className="bg-orange p-2 rounded-lg">
                        Random
                      </button>
                      <button className="bg-orange p-2 rounded-lg">
                        Intelli Lab
                      </button>{" "} */}
                    </div>
                    <input
                      type="text"
                      className="text-gray-800 text-sm mt-1 w-full hide-on-print"
                      placeholder="Search"
                      value={nextConfirmationDOS}
                      onChange={(e) => setNextConfirmationDOS(e.target.value)}
                      style={{ marginBottom: "10px", padding: "5px" }}
                    />
                  </th>
                  <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    #Of <br></br>Confirmation <br></br>{" "}
                    <p className="text-sm">
                      ({getDaysPassed(new Date())}) <br></br>
                      {getCurrentMonthName(new Date())}
                    </p>
                    <div className="flex flex-row items-center justify-around">
                      <a className="hover:underline cursor-pointer">Req</a>
                      <a className="hover:underline cursor-pointer">Result</a>
                    </div>
                  </th>
                  <th
                    scope="col"
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-black"
                  >
                    <table width="100%" cellpadding="3" cellspacing="1">
                      <tbody>
                        <tr>
                          <td colspan="2" align="center">
                            #Of <br></br>Confirmation <br></br>{" "}
                            <p className="text-sm">
                              (Year <br></br>
                              {getDateRangeForYear(new Date()).map(
                                (line, index) => (
                                  <span key={index}>
                                    {line}
                                    <br />
                                  </span>
                                ),
                              )}
                              )
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td width="50%">Req</td>
                          <td width="50%">
                            <span>Result</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </th>
                </>
              )}
              {view === "All" && (
                <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                  Total No.<br></br>of Test Run
                </th>
              )}
            </tr>
          </thead>{" "}
          <tbody>
            {tableData && Array.isArray(tableData) ? (
              ((searchTerm ||
                screeningDOS ||
                lastScreeningDOS ||
                confirmationDOS ||
                lastConfirmationDOS ||
                nextConfirmationDOS) !== ""
                ? filteredPatients
                : tableData
              ).map((row, index) => (
                <tr key={row.id} data-tooltip-place="top">
                  <td
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-black border-b"
                  >
                    {index + 1}
                  </td>
                  <td
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-b border-black cursor-pointer text-blue-700 underline"
                    onClick={() => {
                      const url = `/patient-dashboard?patientId=${row?.PatientID}&patientName=${encodeURIComponent(row?.FirstName + row?.LastName)}`;
                      window.open(url, "_blank");
                    }}
                  >
                    {`${row?.LastName || ""}, ${row?.FirstName || ""}`}
                  </td>
                  {view === "Confirmation" ? (
                    <></>
                  ) : (
                    <>
                      <td
                        style={{ whiteSpace: "nowrap", cursor: "pointer" }}
                        className="p-2 border-r border-black border-b"
                        onClick={() =>
                          (window.location.href = `/patient/${row.PatientID}`)
                        }
                      >
                        {row?.SCRDOS}
                        <div className="flex flex-row gap-1">
                          {row?.SCRDOS === row?.LastSCRDOS ? (
                            <FaCheckCircle className="text-blue-500" />
                          ) : (
                            <FaStar className="text-red-500" />
                          )}
                          {row?.SCRDOS && (
                            <a
                              href={row.SCRReqFilePath}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="cursor-pointer"
                            >
                              <FaFilePdf className="text-red-400" />
                            </a>
                          )}
                        </div>
                      </td>
                      <td
                        style={{ whiteSpace: "nowrap" }}
                        className="p-2 border-r border-black border-b "
                      >
                        {row?.LastSCRDOS}
                      </td>
                      <td
                        style={{ whiteSpace: "nowrap" }}
                        className="p-2 border-r border-black border-b "
                      >
                        <input type="checkbox" />
                        {row?.NextSCRDOS}
                      </td>
                      <td className="p-2 border-r border-black border-b ">
                        <table width="100%" cellpadding="2" cellspacing="1">
                          <tbody>
                            <tr>
                              <td width="50%">
                                <a
                                  id="healthivaAdminContent_gvLabReconData_lblBloodTotal"
                                  onClick={() => toggle(row?.PatientID)}
                                  className="text-blue-700 cursor-pointer underline"
                                >
                                  {row?.SCRYearlytReqCount}
                                </a>
                              </td>
                              <td width="50%">
                                <a
                                  id="healthivaAdminContent_gvLabReconData_lblBloodTotalRecvd"
                                  onClick={() => toggle(row?.PatientID)}
                                  className="text-blue-700 cursor-pointer underline"
                                // style="color:Green;"
                                >
                                  {row?.SCRYearlytResultCount}
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td className="p-2 border-r border-black border-b ">
                        <table width="100%" cellpadding="2" cellspacing="1">
                          <tbody>
                            <tr>
                              <td width="50%">
                                <a
                                  id="healthivaAdminContent_gvLabReconData_lblBloodTotal"
                                  onClick={() => toggle(row?.PatientID)}
                                  className="text-blue-700 cursor-pointer underline"
                                >
                                  {row?.SCRMonthlyReqCount}
                                </a>
                              </td>
                              <td width="50%">
                                <a
                                  id="healthivaAdminContent_gvLabReconData_lblBloodTotalRecvd"
                                  onClick={() => toggle(row?.PatientID)}
                                  className="text-blue-700 cursor-pointer underline"
                                // style="color:Green;"
                                >
                                  {row?.SCRMonthlyResultCount}
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </>
                  )}
                  {view === "Screening" ? (
                    <></>
                  ) : (
                    <>
                      <td
                        style={{ whiteSpace: "nowrap" }}
                        className="p-2 border-r border-black border-b"
                      >
                        {row?.CNFDOS}
                        <div className="flex flex-row gap-1">
                          {row?.CNFDOS === row?.LastCNFDOS ? (
                            <FaCheckCircle className="text-blue-500" />
                          ) : (
                            <FaStar className=" text-red-500" />
                          )}
                          {row?.CNFDOS && (
                            <a
                              href={row.CNFReqFilePath}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="cursor-pointer"
                            >
                              <FaFilePdf className="text-red-400" />
                            </a>
                          )}
                        </div>
                      </td>
                      <td
                        style={{ whiteSpace: "nowrap" }}
                        className="p-2 border-r border-black border-b"
                      >
                        {row?.LastCNFDOS}
                      </td>
                      <td
                        style={{ whiteSpace: "nowrap" }}
                        className="p-2 border-r border-black border-b"
                      >
                        <input type="checkbox" />
                        {row?.NextCNFDOS}
                      </td>

                      <td className="p-2 border-r border-black border-b">
                        <table width="100%" cellpadding="2" cellspacing="1">
                          <tbody>
                            <tr>
                              <td width="50%">
                                <a
                                  id="healthivaAdminContent_gvLabReconData_lblBloodTotal"
                                  onClick={() => toggle(row?.PatientID)}
                                  className="text-blue-700 cursor-pointer underline"
                                >
                                  {row?.CNFYearlytReqCount}
                                </a>
                              </td>
                              <td width="50%">
                                <a
                                  id="healthivaAdminContent_gvLabReconData_lblBloodTotalRecvd"
                                  onClick={() => toggle(row?.PatientID)}
                                  className="text-blue-700 cursor-pointer underline"
                                // style="color:Green;"
                                >
                                  {row?.CNFYearlytResultCount}
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td className="p-2 border-r border-black border-b">
                        <table width="100%" cellpadding="2" cellspacing="1">
                          <tbody>
                            <tr>
                              <td width="50%">
                                <a
                                  id="healthivaAdminContent_gvLabReconData_lblBloodTotal"
                                  onClick={() => toggle(row?.PatientID)}
                                  className="text-blue-700 cursor-pointer underline"
                                >
                                  {row?.CNFMonthlyReqCount}
                                </a>
                              </td>
                              <td width="50%">
                                <a
                                  id="healthivaAdminContent_gvLabReconData_lblBloodTotalRecvd"
                                  onClick={() => toggle(row?.PatientID)}
                                  className="text-blue-700 cursor-pointer underline"
                                >
                                  {row?.CNFMonthlyResultCount}
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </>
                  )}
                  {view === "All" && (
                    <td
                      style={{ whiteSpace: "nowrap" }}
                      className="p-2 border-r border-black border-b"
                    >
                      {row?.TotalTestRun}
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={10} className="p-2 text-center">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LabCompilanceComponent;
